function PaymentMethod(paymentMethod) {
    let method = paymentMethod || {};
    this.id = method.id;
    this.isDefault = method.isDefault;
    this.type = method.type;
    this.lastDigits = method.lastDigits;
    this.name = method.name;
    this.accountHolderName = method.accountHolderName;
}

module.exports = PaymentMethod;